
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { ceaPatientRegister } from '../../../interfaces/report/ceaPatientRegister';

@Injectable()
export class ceaPatientRegisterApi {

  constructor(private api: HttpService) { }

 

  search(url: string, data:any, options?: any):Observable<any[]>{
   
    let header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"}); 
    return this.api.post(url,data,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }


}
